var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.091,
    viewBox: "0 0 16 13.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40452",
    "data-name": "Group 40452",
    transform: "translate(-247.805 -249.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28819",
    "data-name": "Path 28819",
    d: "M263.8,254.9v5.236a2.117,2.117,0,0,1-2.182,2.036H249.987a2.116,2.116,0,0,1-2.182-2.036V254.9a.728.728,0,1,1,1.455,0v5.236a.677.677,0,0,0,.727.582h11.636a.677.677,0,0,0,.727-.582V254.9a.727.727,0,1,1,1.455,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28820",
    "data-name": "Path 28820",
    d: "M257.558,255.024l-1.025,1.033V249.81a.727.727,0,0,0-1.455,0v6.247l-1.025-1.033a.73.73,0,1,0-1.033,1.033l2.269,2.269a.722.722,0,0,0,.465.211h.139a.72.72,0,0,0,.393-.175h.036l2.269-2.3a.73.73,0,0,0-1.033-1.033Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportWhite);
export default __webpack_public_path__ + "static/media/import_white.b395c2231f37097ffc6cf67f65cc6481.svg";
export { ForwardRef as ReactComponent };